var map = {
	"./A-Student.png": "556b",
	"./B-Senior.png": "a979",
	"./C-Avrej.png": "a024",
	"./david_sous.png": "fded",
	"./jaime_saba.png": "503b",
	"./moisesguindi.png": "f479",
	"./testimonio-gamliel.png": "6799",
	"./urielhalak.png": "0085"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fb71";